module.exports = __webpack_public_path__ + "img/weixin-temp.97289e39.png";